import React from "react";

const DummyCapability = ({ children }: { children: React.ReactNode }) => {
  return <div>{children}</div>;
};
export default DummyCapability;
